/**
 * WHAT THE ROW IS CURRENTLY LOOKING AT.
 *
 * A focused tile grows sideways into a 16:9 card, and at that size the poster
 * has stopped carrying the title — the artwork is cropped and the two lines of
 * text under it belong to a card that is no longer poster-shaped. Netflix
 * answers this by writing the details out UNDER the row, not on the card, and
 * this store is what makes that possible: exactly one tile in the app is
 * focused at a time, so exactly one item is in here.
 *
 * It is keyed by the focus uid rather than by the item, because the same film
 * is legitimately in two rails at once and both cards must not claim it.
 *
 * The rail that should DRAW this is chosen in CSS (`:has(.poster.focused)`)
 * rather than by plumbing an id through every caller — the container that holds
 * the focused card is the one that reveals its strip, and there is only ever
 * one.
 */
import type { CatalogItem } from '$types';

export const spotlight = $state<{ id: string | null; item: CatalogItem | null; host: Element | null }>({
  id: null,
  item: null,
  host: null
});

/** Called by a tile as it takes focus. */
export function lightUp(id: string, item: CatalogItem, host: Element | null = null): void {
  spotlight.id = id;
  spotlight.item = item;
  spotlight.host = host;
}

/**
 * Called by a tile as it loses focus — and it only clears if the tile asking is
 * the tile that set it. Without that check, a card losing focus a frame AFTER
 * its neighbour gained it would blank the strip the neighbour had just filled.
 */
export function lightDown(id: string): void {
  if (spotlight.id !== id) return;
  spotlight.id = null;
  spotlight.item = null;
  spotlight.host = null;
}
